import api from '@stencil/megatron/src/api';

import {getDeviceID, getMAPIBaseUrl, isLoggedIn} from '@stencil/hotels-utils/src/common-utils';
import {getDeviceInfo} from '@stencil/hotels-utils/src/device-info';
import {
  getDeviceDetail,
  getSearchCriteria,
  getRequestDetails,
  getVisitNumber,
  getRoomStayCandidatesListWithAgeQualifying,
} from './apiUtils';
import {ALTERNATE_DATE_BASE_URL} from './apiUrls';
import {getExperimentData} from '@stencil/hotels-utils/src/get-experiment-data';

export const prepareAlternateRequest = requestObj => {
  const {
    urlParams,
    pokus,
    selectedCurrency,
    requiredFlags,
    travellerEmailId,
    flavour,
    roomCriteria,
    searchType,
    client,
  } = requestObj;

  const searchCriteria = getSearchCriteria({urlParams, selectedCurrency, travellerEmailId});
  return {
    appVersion: getDeviceInfo().isDesktopDevice ? getDeviceInfo()?.browserVersion : '8.9.0',
    appliedFilterMap: {},
    bestOffersLimit: 2,
    bookingDevice: client,
    channel: 'B2Cweb',
    checkin: searchCriteria?.checkIn,
    checkout: searchCriteria?.checkOut,
    cohertVar: {
      apps: [],
      isLoggedIn: isLoggedIn(),
    },
    countryCode: searchCriteria?.countryCode,
    cityCode: searchCriteria?.cityCode,
    couponCount: 1,
    currency: searchCriteria?.currency,
    deviceId: getDeviceID(),
    deviceType: client,
    email: '',
    experimentData: getExperimentData({pokus}),
    expiryRequired: true,
    firstTimeUserState: 3,
    guestRecommendationEnabled: {
      maxRecommendations: '1',
      text: 'true',
    },
    giHotelIds: [urlParams?.giHotelId],
    brand: 'GI',
    vcId: urlParams?.cityId || '2820046943342890302', //to be removed once vcid dependency is not needed,
    idContext: 'B2C',
    isLoggedIn: false,
    locationId: urlParams?.locusId,
    locationType: urlParams?.locusType,
    mobileCountryCode: '91',
    numberOfAddons: 3,
    pEmailId: '',
    pageContext: 'DETAIL',
    requestType: 'B2CAgent',
    responseFilterFlags: {
      applyAbsorption: true,
      bestCoupon: true,
      mmtPrime: false,
      roomLevelDetails: true,
      walletRequired: true,
    },
    roomStayCandidates: getRoomStayCandidatesListWithAgeQualifying(
      searchCriteria?.roomStayCandidates,
    ),
    srCon: '',
    srCty: '',
    visitNumber: getVisitNumber(),
    visitorId: getDeviceID(),
  };
};

export const fetchAlternateDate = async (requestObj, client = 'DESKTOP') => {
  const obj = {
    ...requestObj,
    client,
  };
  const searchRoomsRequestObj = prepareAlternateRequest(obj);

  return await api.post(
    getMAPIBaseUrl(),
    `${ALTERNATE_DATE_BASE_URL}?versioncode=654&brand=GI&flavour=${client}`,
    searchRoomsRequestObj,
    true,
  );
};
